import React from "react";
import {
  CreateButton,
  Datagrid,
  List,
  ListProps,
  TextField,
  TextInput,
  TopToolbar,
  Filter,
  FilterProps,
} from "react-admin";
import { DateTimeField } from "lib/components/DateTime";

const CountryFilter = (props: Partial<FilterProps>): JSX.Element => (
  <Filter {...props}>
    <TextInput
      label="Name"
      source="name"
      alwaysOn
      style={{ minWidth: "340px" }}
    />
    <TextInput
      label="Country Code"
      source="isoCode"
      alwaysOn
      style={{ minWidth: "340px" }}
    />
  </Filter>
);

const CountryListActions = (props: any): JSX.Element => (
  <TopToolbar {...props}>
    <CreateButton />
  </TopToolbar>
);

export function CountriesList(props: ListProps): JSX.Element {
  return (
    <List
      {...props}
      perPage={30}
      bulkActionButtons={false}
      actions={<CountryListActions />}
      filters={<CountryFilter />}
    >
      <Datagrid>
        <TextField source="name" />
        <TextField source="isoCode" label="Country Code" />
        <DateTimeField source="createdAt" label="Created At" />
        <DateTimeField source="updatedAt" label="Updated At" />
      </Datagrid>
    </List>
  );
}
